import axiosInstance from "./axios";

// Get all themes
const getAllThemes = () => {
  return axiosInstance
    .get("/themes")
    .then(({ data }) => data)
    .catch((e) => e.response.data);
};

// Get a single theme
const getTheme = (themeId) => {
  return axiosInstance.get(`/themes/${themeId}`);
};

// Create a theme
const createTheme = (themeData) => {
  return axiosInstance.post("/themes", themeData);
};

// Update a theme
const updateTheme = ({ id, data }) => {
  return axiosInstance.put(`/themes/${id}`, data);
};

// Delete a theme
const deleteTheme = (themeId) => {
  return axiosInstance.delete(`/themes/${themeId}`);
};

// Save image
const saveImage = (data) => {
  const baseApiUrl =
    process.env.REACT_APP_API_LOGIN_URL ||
    "https://api-dev-scoringcapture.lanetalk.com/v1";

  return axiosInstance
    .post(``, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
      baseURL: `${baseApiUrl}/livescores/setting/image`,
    })
    .then(({ data }) => data)
    .catch((e) => {
      return { message: e.response?.data?.error };
    });
};

export {
  getAllThemes,
  getTheme,
  createTheme,
  updateTheme,
  deleteTheme,
  saveImage,
};
